/* ==================================================
 *  Select2
 *  https://select2.github.io/
 *  ==================================================*/

(function () {

  'use strict';

  window.initSelect2 = function (context) {
    context = context || document;

    $(context).find('select:not([multiple])').select2({
      'placeholder': $(this).attr('data-placeholder') || 'Select an option',
      'minimumResultsForSearch': 10
    });
    $(context).find('select[multiple]').select2({
      'placeholder': $(this).attr('data-placeholder') || 'Select an option',
      'minimumResultsForSearch': 10
    });
  };

  window.destroySelect2 = function (context) {
    context = context || document;

    $(context).find('select').each(function (index, element) {
      $(element).css('display', 'inherit').next().remove();
    });
  };

  initSelect2();
})();
